import { gql, useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useGeneralSoContext } from 'src/common/context';
import { GetOfferQuery } from '../types/types';
import { AppRoutes } from 'src/pages/app';

const GET_OFFER_QUERY = gql(`
  query GetOffer($id: String!) {
  getOffer(id: $id) {
    _id
    offerNumber
    soId
    status
    productTypeId
    departmentCode
    productType {
      code
      name
      departmentCode
    }
    productTypeSpecific {
      calculationJson
      includedCoverages {
        code
        variant
        codeDescription
        variantDescription
        disabled
      }
      price {
        price
        discount
        totalPrice
      }
      paidAt
      termsAcceptedAt
    }
    productId
    product {
      name
      brand {
        _id
        code
        name
        shortName
      }
      brandId
      productTypeSpecific {
        onlyPackage,
        packageName,
        offline
      }
    }
  }
}
`);

export function useGetOffer() {
  const { offerId, setOfferId, setSoId } = useGeneralSoContext();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    setIsInitialized(true);
  }, []);

  const { data, loading, error, refetch } = useQuery<GetOfferQuery>(GET_OFFER_QUERY, {
    variables: { id: offerId },
    skip: !offerId,
    fetchPolicy: 'network-only'
  });

  const isLoading = !isInitialized || loading;

  if (data?.getOffer?.status === 'paid' || data?.getOffer?.status === 'active') {
    setOfferId(undefined);
    setSoId(undefined);
    window.location.href = AppRoutes.WEBSHOP.STEP_1;
  }

  return {
    offer: offerId ? data?.getOffer : undefined,
    loading: isLoading,
    error,
    refetch,
    offerId
  };
}
